import { Component, inject } from '@angular/core';
import { AuthenticationService } from '../service/auth/authentication.service';
import { TeilgebietSelectionService } from '../service/common/teilgebiet/teilgebiet-selection.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
    selector: 'tnb-home',
    templateUrl: './home.component.html',
    styleUrls: [
        './home.component.scss',
    ],
    standalone: false,
})
export class HomeComponent {
    authenticationService = inject(AuthenticationService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private route = inject(ActivatedRoute);

    public login() {
        this.authenticationService.login();
    }

    displayLoginError$ = this.route.queryParams.pipe(
        map(params => params['error'] === 'true'),
    );

    public logout() {
        this.teilgebietSelectionService.resetSelection();
        this.authenticationService.logout();
    }

}
